export default {
	id: "iphone-x",
	title: "iPhone X",
	company: "Apple",
	borderRadius: "0.9em",
	borderRadiusThumb: "0.45em",
	colorSide: true,
	bar: {
		img: require("./original/bar.png"),
		pos: ["2.9%", "23.6%", null, "23.6%"]
	},
	styles: [
		{
			title: "normal",
			pos: ["2.9%", "6.5%", "2.9%", "6.5%"],
			colors: [
				{title: "Black", hex: "#000000", img: require("./original/black.png")}
			]
		}
	]
};
